module.exports = __webpack_public_path__ + "static/font-fb799bfbd4496aeadbdb6bcbe1788a4c.woff2";